// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__3MoOb","label":"Labeled_label__383Gd","divider":"Labeled_divider__1a2FX"};